<template>
  <v-dialog v-model="dialogVisible" max-width="500px" persistent>
    <v-card>
      <v-card-title class="headline"> Pedidos de Extensão </v-card-title>

      <v-card-text>
        <div class="mb-4">
          <ul>
            <li v-for="pedido in pedidos" :key="pedido.id" class="list-group-item">
              O professor(a) {{ pedido.solicitante.name }} fez um pedido de extensão para a etapa:
              {{ pedido.etapa.descricao }}
            </li>
          </ul>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="fecharModal" :disabled="carregando"> Cancelar </v-btn>
        <v-btn color="primary " dark @click="estender"> Ok </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ModalEstenderEtapa",

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    etapaId: {
      type: [String, Number],
      default: null,
    },
    etapaNome: {
      type: String,
      default: "",
    },
    dataExtensao: {
      type: String,
      default: null,
    },
  },

  mounted() {
    this.getPedidos();
  },

  data() {
    return {
      dialogVisible: false,
      datePickerVisible: false,
      formValid: false,
      carregando: false,
      novaData: this.dataExtensao,
      errorMessages: [],
      pedidos: [],
    };
  },

  computed: {
    dataFormatada() {
      if (!this.novaData) return "";

      const [ano, mes, dia] = this.novaData.split("-");
      return `${dia}/${mes}/${ano}`;
    },

    dataMinima() {
      const hoje = new Date();
      const amanha = new Date(hoje.getTime() + 24 * 60 * 60 * 1000);
      return amanha.toISOString().split("T")[0];
    },
  },

  watch: {
    visible: {
      handler(newVal) {
        this.dialogVisible = newVal;
        if (newVal) {
          this.resetarFormulario();
        }
      },
      immediate: true,
    },

    dialogVisible(newVal) {
      this.getPedidos();
      if (!newVal && this.visible) {
        this.$emit("fechar");
      }
    },

    dataExtensao(newVal) {
      this.novaData = newVal;
    },
  },

  methods: {
    estender() {
      this.fecharModal();
    },
    async getPedidos() {
      this.pedidos = await this.$services.etapasService.getPedidosExtensaoEtapa(this.etapaId);
    },
    validarDataMinima(data) {
      if (!data) return false;

      const hoje = new Date();
      hoje.setHours(0, 0, 0, 0);

      const [dia, mes, ano] = data.split("/");
      const dataSelecionada = new Date(ano, mes - 1, dia);

      return dataSelecionada > hoje;
    },

    resetarFormulario() {
      this.novaData = null;
      this.errorMessages = [];

      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },

    fecharModal() {
      this.dialogVisible = false;
      this.$emit("fechar");
    },

    async solicitarExtensao() {
      if (!this.formValid || !this.etapaId) {
        return;
      }

      this.carregando = true;
      this.errorMessages = [];

      try {
        await this.$services.etapasService.solicitarExtensaoEtapa(this.etapaId);

        this.$emit("sucesso", {
          etapaId: this.etapaId,
          novaData: this.novaData,
        });

        this.$toast.success("Solicitação enviada com sucesso!");
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.fecharModal();
        this.carregando = false;
      }
    },
    async removerExtensao() {
      if (!this.etapaId) return;

      this.$modals.danger({
        title: "Cuidado!",
        message: `Tem certeza que deseja remover a extensão da etapa <strong>${this.etapaNome}</strong>?`,
        confirmationCode: this.etapaId,
        confirmationMessage: `Por favor, digite <strong>${this.etapaId}</strong> para confirmar`,
        buttons: [
          {
            text: "Cancelar",
            callback: () => this.$modals.close(),
            props: { color: "warning", small: true },
          },
          {
            text: "Confirmar",
            disableIfCodeDoesntMatch: true,
            callback: async () => {
              this.$modals.close();
              this.carregando = true;
              try {
                await this.$services.etapasService.estenderEtapa(this.etapaId, null);
                this.$emit("sucesso", { etapaId: this.etapaId, novaData: null });
                this.$toast.success("Extensão removida com sucesso!");
                this.fecharModal();
              } catch (error) {
                this.$handleError(error);
              } finally {
                this.carregando = false;
              }
            },
            props: { color: "error", small: true },
          },
        ],
      });
    },
  },
};
</script>

<style scoped>
.headline {
  padding-bottom: 16px !important;
}

.v-card__text {
  padding-top: 0 !important;
}
</style>
